import moonPhases from '../assests/moonPhases_image.jpg'
import beachImg1 from '../assests/beach_image1.jpg'
import oceanImg from '../assests/ocean_image1.jpg'
import spaceImg from '../assests/space_image1.jpg'
import treeImg1 from '../assests/tree_image1.jpg'
import treeImg2 from '../assests/tree_image2.jpg'
import treeImg3 from '../assests/tree_image3.jpg'
import moutainImg1 from '../assests/mountain_image1.jpg'
import moutainImg2 from '../assests/mountain_image2.jpg'
import moutainImg3 from '../assests/mountain_image3.jpg'


export const imgGallery=[
    {
        name: 'Tree',
        src: treeImg1,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name:'Ocean',
        src:oceanImg,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Mountain',
        src:moutainImg1,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Tree',
        src: treeImg3,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Moon phases',
        src:moonPhases,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Beach',
        src: beachImg1,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Tree',
        src: treeImg2,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name:'Mountain',
        src: moutainImg2,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Space',
        src: spaceImg,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    },
    {
        name: 'Mountain',
        src: moutainImg3,
        text:"Lorem ipsum dolor sit amet consectetur,adipisicing elit. Ratione, blanditiis! Et, qui. "
    }
]